import React from "react";

class BaseErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            errorMessage: "",
            error: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorMessage: error.message, error };
    }

    componentDidCatch(error, errorInfo) {
        console.debug("did catch", error, errorInfo);
        console.debug("error", error);
        console.debug("info", errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Something went wrong.</h1>
                    <p>{this.state.errorMessage}</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default BaseErrorBoundary;
